import { useMutation } from '@tanstack/react-query';
import { exchangeRefreshToken } from '../lib/oauth4webapi/exchangeRefreshToken';
export const useExchangeRefreshTokenMutation = () => {
    return useMutation({
        mutationFn: exchangeRefreshToken,
    });
};
